module.exports = __webpack_public_path__ + "static/media/d6_logo.8d841c64.riv";